module.exports = __webpack_public_path__ + "img/signin.9bb6f61a.png";